<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/k3e1Sh/tc-custom/9781681880006.jpg?1726519075603" alt="This image is the cover for the book Burger Night, Williams-Sonoma"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Burger Night, Williams-Sonoma
      </h1>
      <p class="bookDescription body article font2">
        <b>Raise this tried-and-true weeknight staple to a new level with recipes that showcase the burger’s endless variety of protein and flavor possibilities.</b><br/>  <br/> A burger is a classic dish, whether it’s for a Sunday supper or a backyard barbecue. <i>Burger Night</i> is the comprehensive yet easy-to-follow guide to great burgers. There’s something to please every burger lover: from meaty to vegetarian, classic to creative and simple to elaborate.<br/>  <br/> More than 60 recipes will inspire you to up your bun game, including Gorgonzola-Stuffed Burgers with Grilled Nectarines, Breakfast Burgers, Spiced Lamb Sliders with Romesco Sauce, Crab Burgers with Smashed Avocado, Falafel Burgers with Tahini Cilantro Sauce, and Miso Tofu Burgers with Sauteed Chard &amp; Asian Mayonnaise. Also included are delectable side dishes—from salads to fries—and burger essentials like ketchup, onions, and even vanilla milkshakes.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kate McMillan
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Weldonowen
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?635aeaf1